const faqItems = [
  {
    q: '51吃瓜网入口是什么？有哪些功能？',
    a: '51吃瓜网入口是一个专注于娱乐八卦、明星动态、综艺热议等内容的一站式聚合导航平台。我们提供51吃瓜网站入口、51吃瓜网址最新地址与51吃瓜官方入口，帮助用户快速访问吃瓜内容。平台涵盖热门吃瓜资讯、热度榜单、视频内容、话题标签和专题合集等多种功能，每日实时更新，确保您随时掌握最新娱乐热点。',
  },
  {
    q: '51吃瓜网怎么进？最新地址在哪里？',
    a: '访问51吃瓜网非常简单，您只需通过本站提供的51吃瓜网站入口即可直接进入。本站作为51吃瓜官方入口导航，始终保持最新地址的实时同步更新。如果遇到地址变动，本站会第一时间更新51吃瓜最新地址，确保您通过51吃瓜网入口稳定访问。建议收藏本站，随时获取51吃瓜网在线最新访问方式。',
  },
  {
    q: '51吃瓜网入口的内容多久更新一次？',
    a: '51吃瓜网入口实行7×24小时全天候更新机制，我们的内容团队实时监控全网娱乐动态，第一时间聚合热门吃瓜资讯。热门吃瓜板块每日更新超过1000条最新内容，热度榜单每小时刷新一次，确保您看到的信息始终是最新、最热的。无论是凌晨突发新闻还是傍晚热议话题，51吃瓜网入口都不会让您错过。',
  },
  {
    q: '51吃瓜网入口是否需要注册或付费？',
    a: '51吃瓜网入口目前完全免费开放，您无需注册、无需登录即可浏览全部内容。我们致力于降低吃瓜门槛，让每一位用户都能轻松访问51吃瓜网站入口和51吃瓜网在线内容。未来如果推出会员增值服务，我们会提前公告通知，但基础吃瓜浏览服务将始终保持免费开放。',
  },
  {
    q: '51吃瓜网入口的内容来源是什么？是否可靠？',
    a: '51吃瓜网入口聚合全网多家主流娱乐媒体、社交平台和内容社区的热门资讯，通过多源交叉验证确保信息质量。我们秉持客观中立的立场，仅做内容聚合与导航展示，不编造、不夸大。每条内容都标注来源标签，用户可自行追溯原始出处。如涉及侵权或不实信息，欢迎通过联系我们通道进行反馈。',
  },
  {
    q: '51吃瓜app下载在哪里？支持哪些设备？',
    a: '目前51吃瓜网入口以网页端为主要访问方式，支持电脑、平板和手机浏览器访问，响应式设计确保在各种设备上都有良好的浏览体验。关于51吃瓜app下载的相关信息，请关注本站APP下载区域的公告更新。我们会持续优化移动端体验，未来如有独立客户端发布，将在第一时间通过本站通知。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
            <p className="text-sm md:text-base text-foreground-500">
              关于51吃瓜网入口的常见疑问，这里都有详细解答
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <details key={idx} className="group bg-background-50 rounded-lg overflow-hidden" open={idx === 0}>
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base text-foreground-800 font-medium pr-8">
                    {item.q}
                  </h3>
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-500 transition-colors">
                    <i className="ri-add-line text-sm text-foreground-600 group-open:text-background-50 group-open:hidden"></i>
                    <i className="ri-subtract-line text-sm text-background-50 hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5 pt-0">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}